var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"1rem","width":"calc(100% - 2rem)","height":"calc(100% - 2rem)"}},[_c('assets-type-tree')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }